import { Controller, type FieldValues } from 'react-hook-form';

import FieldEditor from './FieldEditor';
import type { ArrayFieldControllerProps } from './types';

const INSURANCE_POLICY_NOT_MUTABLE_EXEMPT_FIELDS = (index: number) => {
  return [`insurance_policies.${index}.plan_end_date`, `insurance_policies.${index}.priority_type`];
};

function ArrayFieldController<T extends FieldValues>({
  control,
  index,
  isMutable,
  field: receivedField
}: ArrayFieldControllerProps<T>) {
  return (
    <Controller
      control={control}
      name={receivedField.key(index)}
      render={({ field }) => {
        // Required in this format to avoid TS error:
        const renderField =
          'options' in receivedField
            ? {
                key: receivedField.key(index),
                label: receivedField.label,
                type: receivedField.type,
                options: receivedField.options
              }
            : {
                key: receivedField.key(index),
                label: receivedField.label,
                type: receivedField.type
              };

        // Exempt the insurance_policy.plan_end_date field from being immutable
        const isMutableField = INSURANCE_POLICY_NOT_MUTABLE_EXEMPT_FIELDS(index).includes(
          renderField.key
        )
          ? true
          : isMutable;

        return (
          <FieldEditor
            field={renderField}
            isMutable={isMutableField}
            onChange={field.onChange}
            value={field.value}
          />
        );
      }}
    />
  );
}

export default ArrayFieldController;
